<template>
  <div>
    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
      <div class="left_content">
        <div class="column block">
          <h5 class="bk-org titlee">Important Links</h5>
          <ul  :style="` overflow-y: scroll`" ref="sliderL" class="div-hight">
            <li v-for="(item,index) in getPortalPublicData.important_links" :key="index">
              <a @click="openNewTab(item.url)">{{ item.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftSlider",
  data(){
    return {
      height: null,
    }
  },
  created() {
    this.$store.dispatch("callPortalPublicData");
  },
  mounted(){
    this.height = document.body.scrollHeight-this.$refs.sliderL.getBoundingClientRect().top;
  },
  computed: {
    getPortalPublicData() {
      return this.$store.getters.getPortalPublicData;
    },
    getDocHeight(){
      return document.body.scrollHeight;
    }
  },
  methods: {
    openNewTab(url) {
      if(url.startsWith('https')){
        window.open(url);
      }else{
        window.open(`https://${url}`);
      }
      return true;
    },
  },
};
</script>

<style scoped>

</style>
